<fa-stack class="close mt-1" size="1x" (click)="closeModal()">
  <fa-icon [icon]="['fas', 'circle']" stackItemSize="2x" class="circle"></fa-icon>
  <fa-icon [icon]="['far', 'x']" [inverse]="true" stackItemSize="1x" class="circle"></fa-icon>
</fa-stack>
<!-- @if ((this.list | async).length >= 1 || validatePaymenSuccess) { -->
<div class="container_grid success" [class.success]="validatePaymenSuccess">
  <div class="grid">
    @if (shippingEnable) {
      <app-form-shipping-user (form)="shipping($event)" />
    }

    @if (rateEnable) {
      <app-form-shipping-select [listRate]="rate" (rateSelected)="rateSelected($event)" />
    }
    @if (stripeEnable) {
      @if (successPaymentMessage) {
        <p [innerHTML]="message.message" class="message_thanks"></p>
      }
      @if (erroStripe) {
        <p [innerHTML]="message.message" class="message_thanks"></p>
      }

      @if (!message?.error && successPaymentMessage) {
        <p i18n class="text-center">
          El numero de orden es el siguiente: <br />
          {{ message?.id_order }}
        </p>
      }
      <app-form-payment-stripe
        [amount]="amountTotal"
        [user]="dataUser?.destination"
        [rate]="dataRate"
        [listNameProduct]="listNameProduct"
        [listproduct]="listproduct"
        (paymentMethod)="createPaymentIntent($event, amountTotal)"
        [successPaymentMessage]="successPaymentMessage"
      />
    }

    @if (enableLoading) {
      <div class="col-12 text-center p-3">
        <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
      </div>
    }

    <!-- <app-stripe (isCompletePayment)="validations($event)" (isDelete)="validationDelete($event)" /> -->
  </div>
  <div class="grid product" [class.none]="validatePaymenSuccess">
    <ul class="produc_list">
      @for (item of list | async; track $index) {
        <li>
          <img [src]="item.image" />
          <p class="stock">{{ item.stock }}</p>
          <p>
            {{ item.name | slice: 0 : 20 }}
          </p>
          <p>
            {{ item.price | currency }}
            @if (isDelete) {
              <fa-icon [icon]="iconTrash" class="ms-2" (click)="deleteProduct(item.id)"></fa-icon>
            }
          </p>
        </li>
      }
    </ul>
    <div class="container_grid price">
      <div>Subtotal</div>
      <div class="text-end">{{ priceSubtotal | currency }}</div>
    </div>
    <div class="container_grid price">
      <div>Envio</div>
      <div class="text-end">
        @if (priceShipping) {
          {{ priceShipping | currency }}
        } @else if (priceShipping === 0) {
          Free
        } @else {
          Calculando...
        }
      </div>
    </div>
    <div class="container_grid price total">
      <div>Total</div>
      <div class="text-end">
        @if (priceTotal > 0) {
          {{ priceTotal | currency }}
        } @else {
          Calculando...
        }
      </div>
    </div>
  </div>
</div>
<!-- }
@if ((this.list | async).length <= 0 && !validatePaymenSuccess) { <div class="container_no_product">
  <h2 class="text-center">No hay productos agregados</h2>
  </div>
  } -->
